import { render, staticRenderFns } from "./AssociateOrgsPanel.vue?vue&type=template&id=d0ddd7ee&scoped=true&"
import script from "./AssociateOrgsPanel.vue?vue&type=script&lang=js&"
export * from "./AssociateOrgsPanel.vue?vue&type=script&lang=js&"
import style1 from "./AssociateOrgsPanel.vue?vue&type=style&index=1&id=d0ddd7ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ddd7ee",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/usage/AssociateOrgsPanel.vue
// module id = 1454
// module chunks = 0